import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SynergySupplierAdminRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.65 7.925H7.6v5.5h6.05v-5.5Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16.4 11.775h-2.75v1.65h2.75v-1.65Z" fill="#21272E" />
            <path
                d="M13.65 10.125h1.572l1.178 1.238v2.062h-2.75v-3.3ZM9.525 15.075a.825.825 0 1 0 0-1.65.825.825 0 0 0 0 1.65ZM15.025 15.075a.825.825 0 1 0 0-1.65.825.825 0 0 0 0 1.65Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
